import type {
  SearchBasePassenger,
  SearchPassenger,
  SearchAdultPassenger,
  SearchYouthSeniorPassenger
} from "@busbud/core-types/dist/lib/search-info";

import type { SearchInfo } from "@app/types/search-types";

import { getPassengersDiscounts } from "./get-passengers-discounts";

export function getPassengers(
  search: Omit<SearchInfo, "origin" | "destination">
) {
  const passengers: SearchPassenger[] = [];

  const adults = getAdultPassengers(search);
  const youth = getYouthPassengers(search);
  const senior = getSeniorPassengers(search);

  if (adults) {
    passengers.push(...adults);
  }
  if (youth) {
    passengers.push(...youth);
  }
  if (senior) {
    passengers.push(...senior);
  }

  return passengers;
}

function getAdultPassengers(
  search: Omit<SearchInfo, "origin" | "destination">
) {
  const passengers: SearchAdultPassenger[] = [];

  const category_discounts = getPassengersDiscounts(search, "adult");
  for (let i = 0; i < search.adult_wheelchair; i++) {
    passengers.push({
      category: "adult",
      ...getBasePassenger(true, category_discounts.pop())
    });
  }

  const remaining_adults = search.adult - search.adult_wheelchair;
  for (let i = 0; i < remaining_adults; i++) {
    passengers.push({
      category: "adult",
      ...getBasePassenger(false, category_discounts.pop())
    });
  }

  return passengers;
}

function getYouthPassengers(
  search: Omit<SearchInfo, "origin" | "destination">
) {
  return getPassengersWithAges("youth", search);
}

function getSeniorPassengers(
  search: Omit<SearchInfo, "origin" | "destination">
) {
  return getPassengersWithAges("senior", search);
}

function getPassengersWithAges(
  category: "senior" | "youth",
  search: Omit<SearchInfo, "origin" | "destination">
) {
  const passengers: SearchYouthSeniorPassenger[] = [];
  const search_info_category = category === "youth" ? "child" : category;
  const category_ages = [...search[`${search_info_category}_ages`]];
  const category_wheelchair_ages = [
    ...search[`${search_info_category}_wheelchair_ages`]
  ];

  const category_discounts = getPassengersDiscounts(search, category);
  for (let i = 0; i < category_ages.length; i++) {
    passengers.push({
      category,
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      age: category_ages[i],
      // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      wheelchair: category_wheelchair_ages[i] > -1,
      // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      discounts: category_discounts[i]
    });
  }

  return passengers;
}

function getBasePassenger(
  wheelchair = false,
  discounts: SearchBasePassenger["discounts"] = []
): SearchBasePassenger {
  return {
    wheelchair,
    discounts
  };
}
